import type { Variants } from 'framer-motion';

/**
 * Shared entrance-animation variants for the Integrations page's stagger-reveal.
 * Consumers pass `initial="hidden" animate="visible"` on the grid container and
 * spread `variants={itemVariants}` on each card.
 *
 * Reduced motion: the page wraps its content in `<MotionConfig reducedMotion="user">`
 * (see IntegrationsPage.tsx), which automatically neutralizes transforms (x/y/scale)
 * for every motion.* descendant when the OS prefers reduced motion — opacity fades
 * still play, so content doesn't just "pop" in, but nothing moves or bounces.
 */
export const containerVariants: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.07,
      delayChildren: 0.02,
    },
  },
};

export const itemVariants: Variants = {
  hidden: { opacity: 0, y: 10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.32, ease: [0.22, 1, 0.36, 1] },
  },
};

/** Gentle collapse/expand for account lists inside a card. */
export const expandVariants: Variants = {
  collapsed: { height: 0, opacity: 0 },
  expanded: {
    height: 'auto',
    opacity: 1,
    transition: { duration: 0.25, ease: [0.22, 1, 0.36, 1] },
  },
};
